<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Listagem dos Declarações de Prestação de Serviço.</span>
                <br />
                <span class="navigation">DPS{{ this.isEmissaoTesteValidacao ? ' (Teste e Validação)' : '' }} -> Consulta</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar
                  id="dataIni"
                  name="dataFim"
                  v-model="dataFatoGeradorIni"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  placeholder="Data Inicial"
                  @keyup.enter="pesquisar"
                  v-maska="'##/##/####'"
                />
              </span>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar
                  id="dataFim"
                  name="dataFim"
                  v-model="dataFatoGeradorFim"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  placeholder="Data Final"
                  @keyup.enter="pesquisar"
                  v-maska="'##/##/####'"
                />
              </span>
            </div>
             <div class="col-md-3 col-lg-2 mb-2">
              <span class="p-fluid">
                <Dropdown id="tipo" v-model="filtroTipo" :options="filtroTipos" optionLabel="name"
                  placeholder="Selecione um Tipo" />
              </span>
            </div>
             <div class="col-md-3 col-lg-2 mb-2">
              <span class="p-fluid">
                <Dropdown id="situacao" v-model="filtroSituacao" :options="filtroSituacoes" optionLabel="name"
                  placeholder="Selecione uma Situação" />
              </span>
            </div>
            <div class="col-md-2 col-lg-1 mb-3">
              <span class="p-fluid">
                <InputText
                  type="text"
                  id="filtroNumero"
                  v-model="filtroNumero"
                  placeholder="Número"
                  autocomplete="off"
                  @keyup.enter="pesquisar"
                />
              </span>
            </div>
            <div class="col-md-2 col-lg-1 mb-3">
              <span class="p-fluid">
                <Button
                  label="Pesquisar"
                  title="Pesquisar"
                  icon="pi pi-search"
                  :disabled="search"
                  @click="pesquisar()"
                />
              </span>
            </div>
            <div class="col-md-2 col-lg-1 mb-3">
              <span class="p-fluid">
                <Button
                  label="Limpar"
                  title="Limpar"
                  icon="pi pi-trash"
                  :disabled="search"
                  @click="clear()"
                />
              </span>
            </div>
          </div>
          <div class="row">
            <DataTable
              :value="dplsList"
              :paginator="true"
              :rows="10"
              class="p-datatable-responsive"
              :autoLayout="true"
            >
              <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button
                    type="button"
                    icon="pi pi-pencil"
                    title="Editar DPS"
                    style="margin-right: .5em"
                    v-show="slotProps.data.tipoDescricao === 'Sistema' && slotProps.data.modelo !== 'A' && slotProps.data.modelo !== 'D' && (slotProps.data.processado === 'A' || slotProps.data.processado === 'E')"
                    @click="detail(slotProps.data.id)"
                  ></Button>
                  <Button
                    type="button"
                    icon="pi pi-times-circle"
                    title="Erros de Transmissão"
                    style="margin-right: .5em"
                    v-show="slotProps.data.situacaoDescricao === 'Processado com Erros'"
                    @click="errosTransmissao(slotProps.data.id)"
                  ></Button>
                </template>
              </Column>
              <Column field="idDps" header="DPS"></Column>
              <Column field="tipoDescricao" header="Tipo"></Column>
              <Column field="situacaoDescricao" header="Situação"></Column>
              <Column field="dataRegistro" header="Data"></Column>
              <Column field="numeroNfseReservado" header="Número Nfs Reservado"></Column>
              <Column field="chaveNacional" header="Chave Nacional"></Column>
            </DataTable>
          </div>
          <hr />

          <div class="row">
            <span class="p-fluid mr-2">
              <router-link to="/emissaoNfseTeste">
                <Button type="button" icon="pi pi-plus" label="Novo" title="Novo" />
              </router-link>
            </span>
            
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Erros Transmissão" :visible.sync="showErrosDps" :style="{width: '50vw'}" :modal="true">
      <div id="dpsDadosId" tabindex="-1" class="row" v-if="((errosDps && errosDps.length > 0) || chaveAcesso)">
          <div class="col-12 mb-2">
            <Panel :toggleable="false" v-if="chaveAcesso" header="Transmissão Realizada com Sucesso">
              <div style="padding: 10px 0;">
                <Message severity="success" :closable="false">
                  DPS transmitida com sucesso para o nota nacional chave acesso gerada: <strong>{{ chaveAcesso }}</strong>
                </Message>
              </div>
            </Panel>
            <Panel :toggleable="false" v-if="!chaveAcesso && errosDps && errosDps.length > 0" header="Pendências / Erros de Transmissão da DPS Nacional">
              <div class="erros-dps-container">
                <div v-for="(erro, index) in errosDps" :key="index" class="erro-dps-card mb-3">
                  <div class="erro-dps-header d-flex align-items-center justify-content-between">
                    <span class="erro-dps-code">
                      <i class="pi pi-exclamation-triangle mr-2"></i>
                      Código: <strong>{{ erro.codigo || 'N/A' }}</strong>
                    </span>
                  </div>
                  <div class="erro-dps-body mt-2">
                    <div class="erro-dps-desc">
                      {{ erro.descricao }}
                    </div>
                    <div v-if="erro.complemento" class="erro-dps-comp mt-2">
                      <span class="text-muted">Complemento:</span> {{ erro.complemento }}
                    </div>
                  </div>
                </div>
              </div>
            </Panel>
           
          </div>
        </div>
      <hr/>
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="showErrosDps = false"
          title="Não"
          class="p-button-secondary"
        />
    </Dialog>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import NotaFiscalNacionalService from "../services/nfse/notafiscalnacional.service";
import CustomCalendar from '../components/global/CustomCalendar.vue';


export default {
  name: "perfil",
  props: {
    testeValidacao: Boolean,
  },
  watch: {
    $route(to, from) {
      //Força reload quando alterna entre as páginas de emissão, pois as duas rotas usam o mesmo componente.
      if (
        (to.path == '/consultaDps' && from.path == '/consultaDpsTeste') ||
        (to.path == '/consultaDpsTeste' && from.path == '/consultaDps')
      ) {
        this.pesquisar();
      }
    },
  },
  components: {
    CustomCalendar,
  },

  data() {
    return {
      loading: false,
      display: false,
      search: false,
      currentUser: null,
      filtro: "",
      dplsList: [],
      dpsId: null,
      admin: 'N',
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      filtroNumero: null,
      filtroSituacao: null,
      filtroSituacoes: [
        { name: "Todos", key: "T" },
        { name: "Processado com Sucesso", key: "S" },
        { name: "Processado com Erros", key: "E" },
        { name: "Aguardando Transmissão", key: "A" },
        { name: "Aguardando Pagamento", key: "P" }
      ],
      filtroTipo: null,
      filtroTipos: [
        { name: "Todos", key: "T" },
        { name: "Sistema", key: "M" },
        { name: "API", key: "A" }
      ],
      showErrosDps: false,
      errosDps: [],
      chaveAcesso: null,
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.filtroTipo = this.filtroTipos.filter(
                    tipo => tipo.key == 'T'
                  )[0];
    this.filtroSituacao = this.filtroSituacoes.filter(
                    tipo => tipo.key == 'T'
                  )[0];
    this.dataFatoGeradorIni = new Date();
    this.dataFatoGeradorIni.setDate(this.dataFatoGeradorIni.getDate() - 60);
    this.dataFatoGeradorFim = new Date();
    //só possibilitara a edição se o parametro admin tiver na url usuarios estão indevidamente bloqueando os grupos
    this.pesquisar();
  },
  methods: {
    clear() {
      this.filtroNumero = "";
      this.filtroTipo = this.filtroTipos.filter(
                    tipo => tipo.key == 'T'
                  )[0];
    this.filtroSituacao = this.filtroSituacoes.filter(
                    tipo => tipo.key == 'T'
                  )[0];
      this.pesquisar();
    },
    pesquisar() {
       if (!this.dataFatoGeradorIni) {
        this.$root.$emit("alert:warn", "Data Inicial Obrigatório para consulta!");
        return;
      }
      if (!this.dataFatoGeradorFim) {
        this.$root.$emit("alert:warn", "Data Final Obrigatório para consulta!");
        return;
      }
      this.search = true;
      NotaFiscalNacionalService.findAllDpsByFiltro(
        this.currentUser.usuario.idCliente,
        this.currentUser.contribuinte.idContribuinte,
        this.filtroNumero,
        this.filtroSituacao.key,
        this.filtroTipo.key,
        this.dataFatoGeradorIni,
        this.dataFatoGeradorFim,
        (this.isEmissaoTesteValidacao ? "H" : "P")
      ).then(
        perfil => {
          this.dplsList = perfil.data;
        },
        error => {
          let errorMessage = "Houve um problema listar DPS!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.search = false;
    },
    detail(dpsId) {
      if(this.isEmissaoTesteValidacao){
        this.$router.push({ name: "emissaoNfseTeste", params: { dpsId: dpsId } });
      }else{
        this.$router.push({ name: "emissaoNfse", params: { dpsId: dpsId } });
      }
    },
    async errosTransmissao(dpsId) {
      await this.obterDadosDps(this.currentUser.usuario.idCliente, dpsId);
      if (this.errosDps && this.errosDps.length > 0) {
        this.showErrosDps = true;
      }
    },
    obterDadosDps(idCliente, dpsId){
      return NotaFiscalNacionalService.obterDadosDps(idCliente,dpsId)
        .then(response => {
          if (response.data) {
            if (response.data.erros && response.data.erros.length > 0) {
              this.errosDps = response.data.erros;
              this.chaveAcesso = null;
              return response.data.erros;
            }
            console.log(response.data);
            if (response.data.chaveAcesso) {
              this.chaveAcesso = response.data.chaveAcesso;
              console.log(this.chaveAcesso);
              this.errosDps = [];
            }
          }
          return [];
        })
        .catch(err => {
          console.error("Erro ao obter dados da DPS:", err);
          return [];
        });
    },
    close() {
      this.dpsId = null;
      this.display = false;
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  },

  computed: {
    isEmissaoTesteValidacao() {
      return this.testeValidacao;
    },
  },
};
</script>

<style lang="scss" scoped>

.erros-dps-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.erro-dps-card {
  border: 1px solid #f5c6cb;
  border-left: 5px solid #dc3545;
  background: linear-gradient(135deg, #fffcfc 0%, #fff5f5 100%);
  color: #721c24;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(220, 53, 69, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  padding: 16px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(220, 53, 69, 0.1);
  }
}

.erro-dps-header {
  border-bottom: 1px solid #fbd2d6;
  padding-bottom: 8px;
}

.erro-dps-code {
  font-size: 1.1em;
  color: #c82333;
  display: flex;
  align-items: center;

  i {
    font-size: 1.2em;
    margin-right: 8px;
  }
}

.erro-dps-desc {
  font-size: 1.05em;
  font-weight: 500;
  line-height: 1.5;
}

.erro-dps-comp {
  font-size: 0.95em;
  background-color: rgba(0, 0, 0, 0.02);
  padding: 8px 12px;
  border-radius: 6px;
  border-left: 3px solid #6c757d;
  color: #495057;
}

.erro-dps-msg {
  .msg-title {
    font-size: 0.9em;
    font-weight: bold;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .msg-content {
    margin-bottom: 0;
    background: #ffffff;
    border: 1px solid #e9ecef;
    padding: 10px;
    border-radius: 6px;
    font-size: 0.9em;
    white-space: pre-wrap;
    font-family: 'Courier New', Courier, monospace;
    color: #212529;
    max-height: 250px;
    overflow-y: auto;
  }
}

</style>